var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F58220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36281 17V8.28L4.37881 8.808V7.08L7.29081 5.8H8.60281V17H6.36281ZM15.9349 17V14.968H10.4309V13.256L15.6469 5.8H18.0949V13.096H19.5509V14.968H18.0949V17H15.9349ZM12.7349 13.096H16.0789V8.184L12.7349 13.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge14);
export default __webpack_public_path__ + "static/media/age-14.e64fce0b52b7f7f7b658b2035bbc1f9d.svg";
export { ForwardRef as ReactComponent };